import React from "react";

const PopupsContext = React.createContext();

class PopupsProvider extends React.Component {
  state = {
    loginPopupIsOpen: false,
    registerPopupIsOpen: false,
    linkExpiredPopupIsOpen: false,
    activateAccountPopupIsOpen: false,
    recoverPasswordPopupIsOpen: false,
    changePasswordPopupIsOpen: false,
    recoverPasswordSuccessPopupIsOpen: false,
    subHeaderVisibility: true,
  };

  openLoginPopup = (closeRegisterPopup = false) => {
    this.setState({
      ...this.state,
      loginPopupIsOpen: true,
      registerPopupIsOpen: closeRegisterPopup
        ? false
        : this.state.registerPopupIsOpen,
      recoverPasswordPopupIsOpen: closeRegisterPopup
        ? false
        : this.state.recoverPasswordPopupIsOpen,
    });
  };

  closeLoginPopup = () => {
    this.setState({
      ...this.state,
      loginPopupIsOpen: false,
    });
  };

  openRegisterPopup = (closeLoginPopup = false) => {
    return () => {
      this.setState({
        ...this.state,
        registerPopupIsOpen: true,
        loginPopupIsOpen: closeLoginPopup ? false : this.state.loginPopupIsOpen,
        recoverPasswordPopupIsOpen: closeLoginPopup
          ? false
          : this.state.recoverPasswordPopupIsOpen,
      });
    };
  };

  closeRegisterPopup = (activateAccountPopupIsOpen = false) => {
    this.setState({
      ...this.state,
      registerPopupIsOpen: false,
      activateAccountPopupIsOpen: activateAccountPopupIsOpen,
    });
  };

  openLinkExpiredPopup = () => {
    this.setState({
      ...this.state,
      linkExpiredPopupIsOpen: true,
    });
  };

  closeLinkExpiredPopup = () => {
    this.setState({
      ...this.state,
      linkExpiredPopupIsOpen: false,
    });
  };

  openActivateAccountPopup = () => {
    this.setState({
      ...this.state,
      activateAccountPopupIsOpen: true,
    });
  };

  closeActivateAccountPopup = () => {
    this.setState({
      ...this.state,
      activateAccountPopupIsOpen: false,
    });
  };

  openRecoverPasswordPopup = () => {
    this.setState({
      ...this.state,
      recoverPasswordPopupIsOpen: true,
      loginPopupIsOpen: false,
    });
  };

  closeRecoverPasswordPopup = () => {
    this.setState({
      ...this.state,
      recoverPasswordPopupIsOpen: false,
    });
  };

  openChangePasswordPopup = () => {
    this.setState({
      ...this.state,
      changePasswordPopupIsOpen: true,
    });
  };

  closeChangePasswordPopup = () => {
    this.setState({
      ...this.state,
      changePasswordPopupIsOpen: false,
    });
  };

  openRecoverPasswordSuccessPopup = () => {
    this.setState({
      ...this.state,
      recoverPasswordSuccessPopupIsOpen: true,
      recoverPasswordPopupIsOpen: false,
    });
  };

  closeRecoverPasswordSuccessPopup = () => {
    this.setState({
      ...this.state,
      recoverPasswordSuccessPopupIsOpen: false,
    });
  };

  subHeaderVisibilitySwitch = (value) => {
    if (this.state.subHeaderVisibility !== value) {
      this.setState({
        ...this.state,
        subHeaderVisibility: value,
      });
    }
  };

  render() {
    return (
      <PopupsContext.Provider
        value={{
          state: this.state,
          openLoginPopup: this.openLoginPopup,
          closeLoginPopup: this.closeLoginPopup,
          openRegisterPopup: this.openRegisterPopup,
          closeRegisterPopup: this.closeRegisterPopup,
          openLinkExpiredPopup: this.openLinkExpiredPopup,
          closeLinkExpiredPopup: this.closeLinkExpiredPopup,
          openActivateAccountPopup: this.openActivateAccountPopup,
          closeActivateAccountPopup: this.closeActivateAccountPopup,
          openRecoverPasswordPopup: this.openRecoverPasswordPopup,
          closeRecoverPasswordPopup: this.closeRecoverPasswordPopup,
          openChangePasswordPopup: this.openChangePasswordPopup,
          closeChangePasswordPopup: this.closeChangePasswordPopup,
          openRecoverPasswordSuccessPopup: this.openRecoverPasswordSuccessPopup,
          closeRecoverPasswordSuccessPopup:
            this.closeRecoverPasswordSuccessPopup,
          subHeaderVisibilitySwitch: this.subHeaderVisibilitySwitch,
        }}
      >
        {this.props.children}
      </PopupsContext.Provider>
    );
  }
}

const PopupsConsumer = PopupsContext.Consumer;

export { PopupsContext, PopupsProvider, PopupsConsumer };
